import {useEffect} from 'react'
import {Grid, Stack, Typography} from '@mui/material'
import FormTextField from 'src/components/ui/TextField'
import FormSelectField from 'src/components/ui/Select'
import FormCheckbox from 'src/components/ui/Checkbox'
import {useFormContext} from 'react-hook-form'
import {StipendCalendarType} from 'src/enum/stipendCalendarType'
import {HEBREW_DAY_LABELS} from 'src/utils/hebrewDayLabels'

const calendarTypeOptions = [
  {Id: StipendCalendarType.Hebrew, Description: 'לוח עברי'},
  {Id: StipendCalendarType.Gregorian, Description: 'לוח לועזי'}
]

const hebrewDayOptions = Array.from({length: 30}, (_, i) => ({
  Id: i + 1,
  Description: HEBREW_DAY_LABELS[i + 1]
}))

const PaymentMethod = () => {
  const {setValue, watch} = useFormContext()
  const stipendCalendarType = watch('stipendCalendarType')
  const isHebrew = stipendCalendarType === StipendCalendarType.Hebrew

  useEffect(() => {
    setValue('stipendPaymentDay', '')
  }, [stipendCalendarType, setValue])

  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="h6">אופן התשלום לאברכים:</Typography>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <FormSelectField
            name="stipendCalendarType"
            label="תשלום חודשי לפי"
            options={calendarTypeOptions}
          />
        </Grid>
        <Grid item xs={2}>
          {isHebrew ? (
            <FormSelectField
              name="stipendPaymentDay"
              label="יום התשלום החודשי"
              options={hebrewDayOptions}
            />
          ) : (
            <FormTextField
              name="stipendPaymentDay"
              label="יום התשלום החודשי"
              type="number"
            />
          )}
        </Grid>
        <Grid item xs={6} display="flex" alignItems="center">
          <FormCheckbox
            name="receivesDatotBudget"
            label="המוסד מקבל תקציב דתות"
          />
        </Grid>
      </Grid>
    </Stack>
  )
}

export default PaymentMethod
